export enum TableLayoutMode {
  Default,
  Flex,
  Card,
  CardFlex
}
